export default function kebabToCamel(input) {
  return input.replace(/-([a-z])/g, (_, group1) => group1.toUpperCase());
}
